import React, { useEffect, useMemo, useRef, useState } from "react";
import { connect } from "react-redux";
import {
  Container,
  Typography,
  Box,
  Grid,
  Paper,
  Chip,
  makeStyles,
  CircularProgress,
} from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import DataTable, { TableColumn } from "react-data-table-component";
import { tableCustomStyles } from "../../utils/table-styles";
import PaginatedTableTop, { paginationTopClassName } from "../shared/paginated-table-top";
import DailyMetrics from "../shared/daily-metrics";
import TicketRangesPanel from "../shared/ticket-ranges-panel";
import { ApiResponse } from "apisauce";
import { toast } from "react-toastify";
import { debounce } from "lodash";
import { orderBy as sort } from "lodash";
import { Tooltip } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";

import {
  useAppDispatch,
  useAppSelector,
  useTicketRangeLimits,
  shouldConfirmBatch,
} from "../../hooks";
import { timeColumn, validateTicketRange } from "../../utils/ticket-helpers";
import { getCurrentUser } from "../../store/userStore";
import { GenerateTicketsFormValues } from "../../interface/formik/GenerateTicketsFormValues";
import {
  getTickets,
  setTicketInTickets,
  setTickets,
  setReceivedTicketCountForToday,
  setUniqueJobSitesCountForToday,
  setUniqueContractorsCountForToday,
  setFilterToggleShowActive,
  setFilterToggleShowReceived,
  getShowActive,
  getShowReceived,
  getTodaysTickets,
  getReceivedTodayCount,
  getReceivedTicketCountForToday,
  getUniqueJobSitesCountForToady,
  getUniqueContractorsCountForToday,
} from "../../store/ticketStore";
import { SetTicketsAction } from "../../interface/redux-types/SetTicketsAction";
import { Ticket } from "../../interface/api/Ticket";
import { history } from "../..";
import { GenerateTicketsPayload } from "../../interface/api/GenerateTicketsPayload";
import {
  clearContractorCompanyContacts,
  setContractorCompanies,
} from "../../store/contractorStore";
import {
  getTrucks,
  setTransportCompanies,
  setTrucks,
} from "../../store/transportStore";
import { ContractorCompany } from "../../interface/api/ContractorCompany";
import { TransportCompany } from "../../interface/api/TransportCompany";
import { SetContractorCompaniesAction } from "../../interface/redux-types/SetContractorCompaniesAction";
import { SetTransportCompaniesAction } from "../../interface/redux-types/SetTransportCompaniesAction";
import ticketService from "../../services/ticketService";
import contractorCompanyService from "../../services/contractorCompanyService";
import transportCompanyService from "../../services/transportCompanyService";
import { SearchTicketsFormValues } from "../../interface/formik/SearchTicketsFormValues";
import UpdateBulkTicketsForm from "./forms/update-bulk-tickets-form";
import PageHero from "../shared/page-hero";
import { isAdmin, a11yProps } from "../../utils/constants";
import { formatTicketNumber } from "../../utils/parser";
import { TicketPayload } from "../../interface/api/TicketPayload";
import { SetTicketInTicketsAction } from "../../interface/redux-types/SetTicketInTicketsAction";
import { Load } from "../../interface/api/soilflo/Load";
import { UpdateSoilFLOTicketResponse } from "../../interface/api/UpdateSoilFLOTicketResponse";
import { TicketSoilFLOPayload } from "../../interface/api/soilflo/TicketSoilFLOPayload";
import useWindowSize from "../../hooks/useWindowSize";
import { formatDate } from "../../utils/date-helper";
import scaleService from "../../services/scaleService";
import { MaterialType } from "../../interface/api/MaterialType";
import { SetMaterialTypesAction } from "../../interface/redux-types/SetMaterialTypesAction";
import { setMaterialTypes } from "../../store/scaleStore";
import ReceiveDialog from "../shared/dialog/receive";
import {
  ActionIconGroup,
  DigitalTicketIcon,
  NotCompleteIcon,
  PrintIcon,
  ReceivedIcon,
  ReceiveIcon,
  SoilFLOIcon,
  SpinningRefreshIcon,
  StatusIconGroup,
  TicketEditIcon,
  TicketLogsIcon,
  TruckDispatchIcon,
  ViewHaulageRecordIcon,
} from "../shared/icons";
import GenerateTicketsForm from "./forms/generate-tickets-form";
import ConfirmGenerateTicketsDialog from "../shared/dialog/confirm-generate-tickets";
import GenerateTicketsProgressDialog from "../shared/dialog/generate-tickets-progress";
import TicketsExcelExportForm from "./forms/tickets-excel-export-form";
import { GenerateExcelExportFormValues } from "../../interface/formik/GenerateExcelExportFormValues";
import { GenerateExcelExportPayload } from "../../interface/api/GenerateExcelExportPayload";
import SearchTicketsForm from "./forms/search-tickets-form";
import { ReceiveIncompleteTicketFormValues } from "../../interface/formik/ReceiveIncompleteTicketFormValues";
import { TabPanel } from "../shared/tab-panel";
import truckService from "../../services/truckService";
import { Truck } from "../../interface/api/Truck";
import { SetTrucksAction } from "../../interface/redux-types/SetTrucksAction";
import useFocusSearch from "../../hooks/useFocusSearch";
import useTimeout from "../../hooks/useTimeout";
import { ContractorCompaniesWithThresholdsResponse } from "../../interface/api/ContractorCompaniesWithThresholdsResponse";
import ClearBulkTicketsForm from "./forms/clear-bulk-tickets-form";
import { SearchPayload } from "../../interface/api/SearchPayload";
import { GenerateTicketsResponse } from "../../interface/api/GenerateTicketsResponse";
import BulkReceiveTicketsForm from "./forms/bulk-receive-tickets-form/index";
import { BulkReceiveTicketsPayload } from "../../interface/api/BulkReceiveTicketsPayload";
import { BulkReceiveTicketsFormValues } from "../../interface/forms/BulkReceiveTicketsFormValues";
import { BulkReceiveTicketsPayloadResponse } from "../../interface/api/BulkReceiveTicketsPayloadResponse";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import ReceiptIcon from "@material-ui/icons/Receipt";
import BusinessIcon from "@material-ui/icons/Business";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import { getCompactTruncateStyle } from "../../utils/table-helpers";
import TicketPill from "../shared/ticket-pill";
import SoilFLOOverrideToast from "../shared/soilflo-override-toast";

const useStyles = makeStyles({
  metricContainer: { padding: "15px", marginBottom: "10px" },
  metricText: { marginTop: "8px" },
});

const DashboardView = ({}) => {
  enum TabValues {
    Search,
    Generate,
    Export,
    BulkUpdate,
    BulkClear,
    BulkReceive,
    // Appended so the existing tab indices don't shift.
    Ranges,
  }

  const classes = useStyles();
  const [value, setValue] = useState(TabValues.Search);
  // Range awaiting confirmation / currently generating; drives both dialogs.
  const [generateRange, setGenerateRange] = useState<
    { from: number; to: number; isSoilFLOTicket: boolean } | null
  >(null);
  const [confirmGenerateOpen, setConfirmGenerateOpen] = useState(false);
  // Bumped after a successful generate so the Ranges tab reflects it.
  const [rangesRefresh, setRangesRefresh] = useState(0);
  const [open, setOpen] = useState(false);
  const user = useAppSelector(getCurrentUser);
  const tickets = useAppSelector(getTickets);
  const trucks = useAppSelector(getTrucks);
  const showActive = useAppSelector(getShowActive);
  const showReceived = useAppSelector(getShowReceived);
  const dailyTickets = useAppSelector(getTodaysTickets);
  const receivedTicketCountForToday = useAppSelector(
    getReceivedTicketCountForToday
  );
  const uniqueJobSitesCountForToady = useAppSelector(
    getUniqueJobSitesCountForToady
  );
  const uniqueContractorsCountForToday = useAppSelector(
    getUniqueContractorsCountForToday
  );
  const dispatch = useAppDispatch();
  const { generateMax, exportMax } = useTicketRangeLimits();
  const [pending, setPending] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState<Ticket>();
  const [selectedTicketSoilFLOData, setSelectedTicketSoilFLOData] =
    useState<Load>();
  const { isMobile, windowSize } = useWindowSize();
  const isCompact = Number(windowSize.width) <= 1200;
  const [refreshing, setRefreshing] = useState(false);
  const { focusOnSearchInput, doFocusSearchInput } =
    useFocusSearch("ticketNumber");
  const searchFormRef = useRef<any>();
  const [bulkReceiveTicketsStatus, setBulkReceiveTicketsStatus] = useState<
    string[]
  >([]);

  const generateTicketsFormValues: GenerateTicketsFormValues = {
    from: "",
    to: "",
    isSoilFLOTicket: false,
  };

  const generateExcelExportFormValues: GenerateExcelExportFormValues = {
    from: "",
    to: "",
  };

  const searchTicketsFormValues: SearchTicketsFormValues = {
    ticketNumber: "",
    transportCompanyId: 0,
    contractorCompanyId: 0,
    jobSite: "",
    truckLicensePlate: "",
    truckNumber: "",
    fromDate: null,
    toDate: null,
  };

  const getLatestActiveTickets = () => {
    setRefreshing(true);

    ticketService
      .getLatestActiveTickets()
      .then((response) => {
        if (response.ok) {
          const {
            tickets,
            receivedTicketCountForToday,
            uniqueJobSitesForToday,
            uniqueContractorsForToday,
          } = response.data as {
            tickets: Ticket[];
            receivedTicketCountForToday: number;
            uniqueJobSitesForToday: number;
            uniqueContractorsForToday: number;
          };

          console.log(response.data);

          const setTicketsAction: SetTicketsAction = {
            tickets,
          };

          dispatch(setTickets(setTicketsAction));

          dispatch(setReceivedTicketCountForToday(receivedTicketCountForToday));
          dispatch(setUniqueJobSitesCountForToday(uniqueJobSitesForToday));
          dispatch(
            setUniqueContractorsCountForToday(uniqueContractorsForToday)
          );

          setRefreshing(false);
        } else {
          toast.error(response.originalError.message);
        }
      })
      .finally(() => setRefreshing(false));
  };

  useEffect(() => {
    getLatestActiveTickets();
  }, []);

  useEffect(() => {
    dispatch(clearContractorCompanyContacts());

    contractorCompanyService.getContractorCompanies().then((response) => {
      if (response.ok) {
        const contractorCompaniesWithThresholdsResponse =
          response.data as ContractorCompaniesWithThresholdsResponse;
        const contractorCompanies =
          contractorCompaniesWithThresholdsResponse.contractorCompanies as ContractorCompany[];

        const setContractorCompaniesAction: SetContractorCompaniesAction = {
          contractorCompanies: contractorCompanies,
        };

        dispatch(setContractorCompanies(setContractorCompaniesAction));
      } else {
        toast.error(response.originalError.message);
      }
    });

    transportCompanyService.getTransportCompanies().then((response) => {
      if (response.ok) {
        const transportCompanies = response.data as TransportCompany[];
        const setTransportCompaniesAction: SetTransportCompaniesAction = {
          transportCompanies,
        };

        dispatch(setTransportCompanies(setTransportCompaniesAction));
      } else {
        toast.error(response.originalError.message);
      }
    });

    scaleService.getMaterialTypes().then((response) => {
      if (response.ok) {
        const materialTypes = response.data as MaterialType[];
        const setMaterialTypesAction: SetMaterialTypesAction = {
          materialTypes,
        };

        dispatch(setMaterialTypes(setMaterialTypesAction));
      } else {
        toast.error(response.originalError.message);
      }
    });

    truckService
      .getTrucks({
        transportCompanyId: null,
        truck: null,
        transportContact: null,
      })
      .then((response) => {
        if (response.ok) {
          const trucks = response.data as Truck[];
          const SetTrucksAction: SetTrucksAction = {
            trucks,
          };

          dispatch(setTrucks(SetTrucksAction));
        } else {
          toast.error(response.originalError.message);
        }
      });

    return () => {
      setOpen(false);
    };
  }, []);

  useTimeout(() => focusOnSearchInput(), 500);

  const getNumberOfActiveTickets = useMemo(() => {
    return dailyTickets.filter((t) => t.isReceived === false).length;
  }, [dailyTickets]);

  const getNumberOfReceivedTickets = useAppSelector(getReceivedTodayCount);

  const onTabClick = (_event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  const onOpen = () => setOpen(true);

  const onClose = () => {
    setSelectedTicket(undefined);
    setSelectedTicketSoilFLOData(undefined);
    setOpen(false);
    doFocusSearchInput();
  };

  const onClear = () => getLatestActiveTickets();

  const onReceiveClick = async (ticketId: number) => {
    //make sure to get the freshest data before receiving
    const response = await ticketService.getTicket(ticketId);

    if (!response.ok) {
      toast.error("Failed to get the lastest ticket data");
      return;
    }

    const ticket = response.data as Ticket;

    if (ticket && ticket.isSoilFLOLoad) {
      ticketService.getLoad(ticket.ticketNumber.toString()).then((response) => {
        if (response.ok) {
          const data = response.data as [Load];

          if (data !== null && data.length > 0) {
            const load = sort(data, (t) => t.id, "desc")?.[0];
            setSelectedTicketSoilFLOData(load);

            try {
              const ticketWithSoilFLOData = { ...ticket };

              ticketWithSoilFLOData.jobSite = load.sourceSite.name
                ? load.sourceSite.name
                : "Unknown";
              ticketWithSoilFLOData.siteContactName = load?.assignerUser
                ? `${load.assignerUser.firstName} ${load.assignerUser.lastName} [${load.assignerUser.phone}]`
                : "Unknown";
              ticketWithSoilFLOData.contractorCompanyName = load.sourceSite
                .contractingcompany
                ? load.sourceSite.contractingcompany.name
                : "Unknown";
              ticketWithSoilFLOData.timeLoaded = load.dispatchedTime;
              ticketWithSoilFLOData.transportCompanyName = load.truck
                .global_truck.hauler
                ? load.truck.global_truck.hauler.name
                : "Unknown";
              ticketWithSoilFLOData.truckDriverName = load.truck.driverName
                ? load.truck.driverName
                : "Unknown";
              ticketWithSoilFLOData.truckLicensePlate = load.truck.global_truck
                .license
                ? load.truck.global_truck.license
                : "Unknown";
              ticketWithSoilFLOData.truckNumber = load.truck.global_truck.number
                ? load.truck.global_truck.number
                : "Unknown";

              setSelectedTicket(ticketWithSoilFLOData);
              onOpen();
            } catch (e) {
              toast.error("SoilFLO data is not correct");
            }
          } else {
            toast.error(
              <SoilFLOOverrideToast
                ticketNumber={ticket.ticketNumber}
                onOverride={() => {
                  setSelectedTicket({ ...ticket, isSoilFLOLoad: false });
                  onOpen();
                }}
              />,
              { autoClose: false }
            );
          }
        } else {
          toast.error("Failed to pull SoilFLO data");
        }
      });
    } else {
      setSelectedTicket(ticket);
      onOpen();
    }
  };

  const onReceiveTicket = (
    receiveIncompleteTicketFormValues: ReceiveIncompleteTicketFormValues | null
  ) => {
    let values = { ...selectedTicket };

    if (receiveIncompleteTicketFormValues) {
      values.jobSite = receiveIncompleteTicketFormValues.jobSite;
      values.siteContactName =
        receiveIncompleteTicketFormValues.siteContactName;
      values.transportCompanyName =
        receiveIncompleteTicketFormValues.transportCompanyName;
      values.truckLicensePlate =
        receiveIncompleteTicketFormValues.truckLicensePlate;
      values.truckNumber = receiveIncompleteTicketFormValues.truckNumber;
      values.truckDriverName =
        receiveIncompleteTicketFormValues.truckDriverName;
      values.salePrice = receiveIncompleteTicketFormValues.salePrice;
    }

    values.timeLoaded = null;
    values.isReceived = true;
    values.timeReceived = new Date();

    if (user) {
      values.userId = user.id ? user.id : null;
    }

    if (values.isSoilFLOLoad && selectedTicketSoilFLOData) {
      let ticketSoilFLOPayload = {
        ...values,
      } as unknown as TicketSoilFLOPayload;

      ticketSoilFLOPayload.updateSoilFLO = true;
      ticketSoilFLOPayload.soilFLOData = selectedTicketSoilFLOData;
      ticketSoilFLOPayload.loggedInUserId = user ? user.id : undefined;

      ticketService.saveSoilFLOTicket(ticketSoilFLOPayload).then((response) => {
        if (response.ok) {
          const updateSoilFLOTicketResponse =
            response.data as UpdateSoilFLOTicketResponse;
          if (updateSoilFLOTicketResponse.success) {
            const ticket = updateSoilFLOTicketResponse.ticket;
            const setTicketInTicketsAction: SetTicketInTicketsAction = {
              ticket,
            };
            dispatch(setTicketInTickets(setTicketInTicketsAction));
            searchFormRef.current?.resetForm();
          } else {
            toast.error("Failed to update SoilFLO ticket!");
          }
        } else {
          toast.error(response.originalError.message);
        }
      });
    } else {
      const ticketPayload: TicketPayload = {
        ticket: values as Ticket,
        loggedInUserId: user ? user.id : undefined,
        createTransportIfDoesNotExist: true,
      };

      ticketService.saveTicket(ticketPayload).then((response) => {
        if (response.ok) {
          const ticket = response.data as Ticket;
          const setTicketInTicketsAction: SetTicketInTicketsAction = {
            ticket,
          };
          dispatch(setTicketInTickets(setTicketInTicketsAction));
          searchFormRef.current?.resetForm();
        } else {
          toast.error(response.originalError.message);
        }
      });
    }

    onClose();
  };

  const onGenerateTicketsFormSubmit = (
    values: GenerateTicketsFormValues,
    setSubmitting: Function
  ) => {
    const range = validateTicketRange(values.from, values.to, generateMax);
    if (!range) {
      setSubmitting(false);
      return;
    }

    const request = { ...range, isSoilFLOTicket: values.isSoilFLOTicket };
    setGenerateRange(request);

    if (shouldConfirmBatch(range.from, range.to)) {
      // Formik is released now; the dialog drives the request from here.
      setSubmitting(false);
      setConfirmGenerateOpen(true);
      return;
    }

    runGenerate(request, setSubmitting);
  };

  const runGenerate = (
    request: { from: number; to: number; isSoilFLOTicket: boolean },
    setSubmitting?: Function
  ) => {
    const { from, to, isSoilFLOTicket } = request;
    const range = { from, to };
    setConfirmGenerateOpen(false);
    setPending(true);

    // One request, one transaction. This used to fan out into parallel 1,000-ticket calls,
    // which meant a conflict part-way through left a partially generated range with no
    // rollback and produced a separate error toast per chunk. The server chunks internally.
    const payload: GenerateTicketsPayload = {
      from: range.from,
      to: range.to,
      isSoilFLOTicket,
      email: "",
    };

    ticketService.generateTickets(payload).then((response) => {
      if (response.ok) {
        const data = response.data as GenerateTicketsResponse;
        if (data.success) {
          toast.success("Tickets have been generated successfully.");
          getLatestActiveTickets();
          setRangesRefresh((n) => n + 1);
        } else {
          toast.warning(data.error, { autoClose: 10000 });
        }
      } else {
        toast.warning(
          (response.data as any)?.toString() || "Unexpected error has occurred.",
          { autoClose: 10000 }
        );
      }

      setPending(false);
      setGenerateRange(null);
      setSubmitting?.(false);
    });
  };

  const onTicketsExcelExportFormSubmit = (
    values: GenerateExcelExportFormValues,
    setSubmitting: Function
  ) => {
    var email = user ? user.username : "";

    const range = validateTicketRange(values.from, values.to, exportMax);
    if (!range) {
      setSubmitting(false);
      return;
    }

    const generateExcelExportPayload: GenerateExcelExportPayload = {
      from: range.from,
      to: range.to,
      email,
    };

    ticketService
      .exportTicketsExcel(generateExcelExportPayload)
      .then((response) => {
        if (response.ok) {
          toast.success(
            `Export queued — you'll receive it at ${email} when it's ready.`
          );
        } else {
          const data = response.data as string;
          toast.error(data);
        }

        setSubmitting(false);
      });
  };

  const onSearchTicketsFormSubmit = (
    values: SearchTicketsFormValues,
    setSubmitting: Function
  ) => {
    search(values);
    setSubmitting(false);
  };

  const onSearchTicketNumberChange = (
    values: SearchTicketsFormValues,
    value: string,
    setFieldValue: Function
  ) => {
    setFieldValue("ticketNumber", value);
    if (Number(value)) search({ ...values, ticketNumber: value });
  };

  const onBulkReceiveTicketsFormSubmit = async (
    values: BulkReceiveTicketsFormValues,
    setSubmitting: Function,
    setFieldValue: Function
  ) => {
    for await (let [
      index,
      ticketRange,
    ] of values.listOfTicketRanges.entries()) {
      if (ticketRange.success) continue;

      const payload = {
        ticketRange: ticketRange.ticketRange,
        loggedInUserId: user ? user.id : undefined,
        forceReceive: values.forceReceive,
      } as BulkReceiveTicketsPayload;

      const response = await ticketService.bulkReceiveTickets(payload);

      if (response.ok) {
        const result = response.data as BulkReceiveTicketsPayloadResponse;
        const updatedListOfTicketRanges = [...values.listOfTicketRanges];
        updatedListOfTicketRanges[index].success = result.success;
        updatedListOfTicketRanges[index].fail = result.fail;
        setBulkReceiveTicketsStatus(result.results);
        setFieldValue("listOfTicketRanges", updatedListOfTicketRanges);
      } else {
        const updatedListOfTicketRanges = [...values.listOfTicketRanges];
        updatedListOfTicketRanges[index].fail = true;
        setFieldValue("listOfTicketRanges", updatedListOfTicketRanges);
      }
    }

    setSubmitting(false);
  };

  const onToggleShowActive = () => {
    dispatch(setFilterToggleShowActive());
  };

  const onToggleShowReceived = () => {
    dispatch(setFilterToggleShowReceived());
  };

  const onToggleTicketDispatchLock = (ticketId: number) => {
    const ticket = tickets.find((t) => t.id === ticketId);
    if (!ticket) return;

    const ticketPayload: TicketPayload = {
      ticket: { ...ticket, isDispatched: !ticket.isDispatched },
      loggedInUserId: user ? user.id : undefined,
      createTransportIfDoesNotExist: false,
    };

    ticketService.toggleTicketDispatch(ticketPayload).then((response) => {
      if (response.ok) {
        const ticket = response.data as Ticket;
        const setTicketInTicketsAction: SetTicketInTicketsAction = {
          ticket,
        };
        dispatch(setTicketInTickets(setTicketInTicketsAction));
      }
    });
  };

  const onRefresh = async () => getLatestActiveTickets();

  const onPrint = (ticketId: number) => {
    window.open(
      `/print-record/${ticketId}`,
      "Export Form",
      "width=750,height=750"
    );
  };

  const search = debounce((values: SearchTicketsFormValues) => {
    setRefreshing(true);

    ticketService
      .searchTickets(values as SearchPayload)
      .then((response) => {
        if (response.ok) {
          const tickets = response.data as Ticket[];
          const setTicketsAction: SetTicketsAction = {
            tickets,
          };
          dispatch(setTickets(setTicketsAction));
          setRefreshing(false);
        } else {
          console.error(response.originalError.message);
        }
      })
      .finally(() => setRefreshing(false));
  }, 500);

  const truncateStyle = getCompactTruncateStyle(isCompact);

  const columns: TableColumn<Ticket>[] = [
    {
      name: "",
      width: isCompact ? "100px" : "125px",
      cell: (row) => {
        if (row.isReceived) return <></>;

        return (
          <ReceiveIcon
            isMobile={isCompact}
            onClick={() => onReceiveClick(row.id)}
          />
        );
      },
    },
    {
      name: "Ticket #",
      sortable: true,
      sortFunction: (a, b) => a.ticketNumber - b.ticketNumber,
      width: isCompact ? "130px" : "170px",
      cell: (row) => (
        <TicketPill
          ticketNumber={`[${row.prefix}] ${formatTicketNumber(row.ticketNumber)}`}
          copyValue={formatTicketNumber(row.ticketNumber)}
          isCompact={isCompact}
        />
      ),
    },
    showReceived
      ? timeColumn<Ticket>("Time Received", (row) => row.timeReceived, isCompact)
      : timeColumn<Ticket>("Time Loaded", (row) => row.timeLoaded, isCompact, (row) => row.isSoilFLOLoad),
    {
      name: "Haulage Co.",
      selector: (row) => row.transportCompanyName,
      sortable: true,
      maxWidth: isCompact ? "120px" : undefined,
      style: truncateStyle,
    },
    {
      name: "Truck #",
      selector: (row) => row.truckNumber ?? "",
      sortable: true,
      maxWidth: isCompact ? "100px" : undefined,
      style: truncateStyle,
    },
    {
      name: "License Plate",
      selector: (row) => row.truckLicensePlate ?? "",
      sortable: true,
      maxWidth: isCompact ? "100px" : undefined,
      style: truncateStyle,
    },
    {
      name: "Contractor Company",
      selector: (row) => row.contractorCompanyName,
      sortable: true,
      maxWidth: isCompact ? "120px" : undefined,
      style: truncateStyle,
    },
    {
      name: "Job Site",
      selector: (row) => row.jobSite,
      sortable: true,
      maxWidth: isCompact ? "120px" : undefined,
      style: truncateStyle,
    },
    {
      name: "Status",
      cell: (row) => {
        return (
          <StatusIconGroup>
            {row.isReceived && <ReceivedIcon />}
            {!row.isComplete && <NotCompleteIcon />}
            {row.isSoilFLOLoad && <SoilFLOIcon />}
          </StatusIconGroup>
        );
      },
      width: isCompact ? "80px" : undefined,
    },
    {
      name: "",
      width: isCompact ? "190px" : "250px",
      cell: (row) => {
        return (
          <ActionIconGroup>
            {TruckDispatchIcon(row, onToggleTicketDispatchLock)}
            {TicketEditIcon(row, user)}
            <DigitalTicketIcon
              onClick={() => history.push(`/digital-ticket/${row.id}`)}
            />
            <TicketLogsIcon
              onClick={() => history.push(`/ticket-log/${row.id}`)}
            />
            <ViewHaulageRecordIcon
              onClick={() => history.push(`/haulage-record/${row.id}`)}
            />
            <PrintIcon onClick={() => onPrint(row.id)} />
          </ActionIconGroup>
        );
      },
    },
  ];

  return (
    <Container maxWidth="xl">
      <PageHero
        title="Main Tickets"
        subtitle="Generate, Search, and Bulk Update Tickets."
        showBackButton={false}
      />
      <div>
        <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={onTabClick}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="on"
          aria-label="scrollable tabs"
        >
          <Tab label="Search" {...a11yProps(0)} />
          {user &&
            isAdmin(user.roleId) && [
              <Tab key="generate" label="Generate" {...a11yProps(1)} />,
              <Tab key="export" label="Export" {...a11yProps(2)} />,
              <Tab key="update" label="Update" {...a11yProps(3)} />,
              <Tab key="clear" label="Clear" {...a11yProps(4)} />,
              <Tab
                key="bulk-receive"
                label="Bulk Receive"
                {...a11yProps(5)}
              />,
              <Tab key="ranges" label="Ranges" {...a11yProps(6)} />,
            ]}
        </Tabs>
        </AppBar>
        <TabPanel value={value} index={TabValues.Search}>
          <Box
            sx={{
              marginY: 2,
            }}
          >
            <SearchTicketsForm
              onSubmit={onSearchTicketsFormSubmit}
              searchTicketsFormValues={searchTicketsFormValues}
              onSearchTicketNumberChange={onSearchTicketNumberChange}
              onClear={onClear}
              searchFormRef={searchFormRef}
            />
          </Box>
        </TabPanel>
        <TabPanel value={value} index={TabValues.Generate}>
          <Box
            sx={{
              marginY: 2,
            }}
          >
            <GenerateTicketsForm
              generateTicketsFormValues={generateTicketsFormValues}
              onSubmit={onGenerateTicketsFormSubmit}
            />
          </Box>
        </TabPanel>
        <TabPanel value={value} index={TabValues.Export}>
          <Box
            sx={{
              marginY: 2,
            }}
          >
            <TicketsExcelExportForm
              generateExcelExportFormValues={generateExcelExportFormValues}
              onSubmit={onTicketsExcelExportFormSubmit}
            />
          </Box>
        </TabPanel>
        <TabPanel value={value} index={TabValues.BulkUpdate}>
          <Box
            sx={{
              marginY: 2,
            }}
          >
            <UpdateBulkTicketsForm setPending={setPending} />
          </Box>
        </TabPanel>
        <TabPanel value={value} index={TabValues.BulkClear}>
          <Box
            sx={{
              marginY: 2,
            }}
          >
            <ClearBulkTicketsForm setPending={setPending} />
          </Box>
        </TabPanel>
        <TabPanel value={value} index={TabValues.BulkReceive}>
          <Box
            sx={{
              marginY: 2,
            }}
          >
            <BulkReceiveTicketsForm
              onSubmit={onBulkReceiveTicketsFormSubmit}
              bulkReceiveTicketsStatus={bulkReceiveTicketsStatus}
              setBulkReceiveTicketsStatus={setBulkReceiveTicketsStatus}
            />
          </Box>
        </TabPanel>
        <TabPanel value={value} index={TabValues.Ranges}>
          <Box sx={{ marginY: 2 }}>
            {/* No onUseRange here: the Main Pit Generate tab is a Formik form that owns
                its own values, unlike the sub-stream panels' plain state. */}
            <TicketRangesPanel stream="main" refreshToken={rangesRefresh} />
          </Box>
        </TabPanel>
        {/* Daily metrics and the ticket listing are irrelevant on the Ranges tab. */}
        {value !== TabValues.Ranges && (
          <>
        <Paper variant="outlined" className={classes.metricContainer}>
          <Grid container spacing={2} alignItems="center">
            {/* Left: Metrics */}
            <Grid item xs={12} md={4} className={classes.metricText}>
              <Box display="flex" alignItems="center" mb={1}>
                <LocalShippingIcon style={{ marginRight: 6 }} />
                <Typography
                  variant="h6"
                  style={{ fontWeight: 600, marginRight: 6 }}
                >
                  Daily Trucks
                </Typography>
                <Tooltip title="Daily summary of tickets and unique counts for today." placement="top" arrow>
                  <InfoIcon fontSize="small" color="action" style={{ cursor: "pointer" }} />
                </Tooltip>
              </Box>
              <DailyMetrics
                metrics={[
                  {
                    icon: <LocalShippingIcon fontSize="small" />,
                    value: dailyTickets.length,
                    label: "Loaded",
                  },
                  {
                    icon: <ReceiptIcon fontSize="small" />,
                    value: receivedTicketCountForToday,
                    label: "Received",
                  },
                  {
                    icon: <BusinessIcon fontSize="small" />,
                    value: uniqueContractorsCountForToday,
                    label: "Contractor(s)",
                  },
                  {
                    icon: <LocationOnIcon fontSize="small" />,
                    value: uniqueJobSitesCountForToady,
                    label: "Job Site(s)",
                  },
                ]}
              />
            </Grid>
            {/* Right: Toggles + Refresh */}
            <Grid item xs={12} md={8}>
              <Box display="flex" alignItems="center" justifyContent={isMobile ? "space-evenly" : "flex-end"} flexWrap="wrap" style={{ gap: 4, width: "100%" }}>
                  <Chip
                    label={`Active ${getNumberOfActiveTickets}`}
                    color={showActive ? "primary" : "default"}
                    onClick={onToggleShowActive}
                    variant={showActive ? "default" : "outlined"}
                    size="small"
                    style={isMobile ? { flex: 1 } : undefined}
                  />
                  <Chip
                    label={`Received ${getNumberOfReceivedTickets}`}
                    color={showReceived ? "primary" : "default"}
                    onClick={onToggleShowReceived}
                    variant={showReceived ? "default" : "outlined"}
                    size="small"
                    style={isMobile ? { flex: 1 } : undefined}
                  />
                <Box ml={1}>
                  <SpinningRefreshIcon onClick={onRefresh} refreshing={refreshing} />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Paper>

        <PaginatedTableTop>
          <DataTable
            className={paginationTopClassName}
            customStyles={tableCustomStyles}
            fixedHeader
            striped
            columns={columns}
            data={tickets}
            pagination
            paginationPerPage={50}
            paginationRowsPerPageOptions={[50, 100, 150, 200]}
            progressPending={pending}
            progressComponent={<CircularProgress style={{ margin: 20 }} />}
            highlightOnHover
            responsive
          />
        </PaginatedTableTop>
          </>
        )}
      </div>
      {generateRange && (
        <ConfirmGenerateTicketsDialog
          open={confirmGenerateOpen}
          from={generateRange.from}
          to={generateRange.to}
          onClose={() => {
            setConfirmGenerateOpen(false);
            setGenerateRange(null);
          }}
          onConfirm={() => runGenerate(generateRange)}
        />
      )}
      {generateRange && (
        <GenerateTicketsProgressDialog
          open={pending && !confirmGenerateOpen}
          from={generateRange.from}
          to={generateRange.to}
        />
      )}
      <ReceiveDialog
        open={open}
        onClose={onClose}
        selectedTicket={selectedTicket}
        onReceiveTicket={onReceiveTicket}
        trucks={trucks}
      />
    </Container>
  );
};

export default connect()(DashboardView);
